export default __webpack_public_path__ + "f6274303a911448ca71d3b683a187e6d.png";